import ApiService from "@/common/services/http/api.service";

const MonitorService = {
  /**
   * Buscar Monitor de Pendencias
   * @param grupoID id do grupo
   * @param params filtros opcionais
   * @returns {*}
   */
  async getMonitorPendencias(grupoID, params = null) {
    const { data: result } = await ApiService.get(
      "registro/ListarMonitorPendencias/grupo",
      `${grupoID}`,
      params
    );

    return result;
  },

  /**
   * Buscar Monitor de Pendencias Agregada
   * @param grupoID id do grupo
   * @param params filtros opcionais
   * @returns {*}
   */
  async getMonitorPendenciasAgregada(grupoID, params = null) {
    const { data: result } = await ApiService.get(
      "registro/ListarMonitorPendenciasAgregada/grupo",
      `${grupoID}`,
      params
    );

    return result;
  },

  /**
   * Buscar Monitor de Pendencias
   * @param clienteID id do cliente
   * @param params filtros opcionais
   * @returns {*}
   */
  async getPeriodoPendencias(clienteID, params = null) {
    const { data: result } = await ApiService.get(
      "registro/ListarPeriodoPendencias/cliente",
      `${clienteID}`,
      params
    );

    return result;
  },

  /**
   * Buscar Pendencias de Validade
   * @param grupoID id do grupo
   * @param params filtros opcionais
   * @returns {*}
   */
  async getPendenciasValidade(grupoID, params = null) {
    const { data: result } = await ApiService.get(
      "registro/ListarPendenciasValidade/grupo",
      `${grupoID}`,
      params
    );

    return result;
  },
};

export default MonitorService;
